<template>
    <el-menu background-color="#545c64" text-color="#fff" active-text-color="#ffd04b"
        :default-active="actId"
        :collapse="isCollapse"
        :collapse-transition="false"
        @select="selectMenu" router>
        <el-submenu :index="(''+menu.fMenu.id)" v-for="menu in menuData" :key="menu.fMenu.id">
            <template slot="title">
                <i :class="(menu.fMenu.css==''?'el-icon-s-operation':menu.fMenu.css)"></i>
                <span>{{menu.fMenu.name}}</span>
            </template>
            <el-menu-item v-for="smenu in menu.sMenuList" :key="smenu.id" style="padding-left: 50px" :index="(''+smenu.id)" :route="smenu.linkurl">{{smenu.name}}</el-menu-item>
        </el-submenu>
    </el-menu>
</template>

<script>
export default {
    props: {
        actId: {
            type: String,
            default(){
                return "0"
            }
        },
        menuData: {
            type: Array,
            default() {
                return [];
            },
        },
        isCollapse: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    methods: {
        selectMenu(key, keyPath) {
            this.$emit("selectMenu", { sMenuIndex: key, fMenuIndex: keyPath[0], menu: 1});
        },
    },
};
</script>